/**
 * Recent Searches Controller. Responsible for initializing the recent searches service
 * and syndicating recently searched terms to the UI.
 */
import _ from 'lodash';
import MessageBusTopics from '../../../common/MessageBusTopics';
import RecentSearchService from './services/SearchRecentService';

/**
 * Search Controller contructor
 *
 * @constructor
 */
function SearchRecentController(config, searchService) {

    this.config = config;
    this.searchService = searchService;

    this.recentSearches = new RecentSearchService();

    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_INPUT_CHANGE,
        _.debounce(this.onInputChange.bind(this), this.config.debounceWait)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_EVENTS_SCROLL, this.onEventsScrolled.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_ICON_BAR_SCROLL, this.onIconBarScrolled.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_EVENT_RESULT_ITEM_CLICK, this.onEventResultItemClick.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_ICON_BAR_ITEM_CLICK, this.onIconBarItemClick.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_REQUEST_SUCCESS, this.onRequestSuccess.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_REQUEST_FAILED, this.onRequestFailed.bind(this)
    );
    window.WH.messageBus.subscribe(
        MessageBusTopics.SEARCH_STATE_RESET, this.onStateReset.bind(this)
    );

    this.updateRecentSearches();
}

/**
 * Listen to input and perform a new search if the search value is
 * different from the previous search
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.onInputChange = function () {

    this.updateRecentSearches();
};

/**
 * Listen for the event container scroll event
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.onEventsScrolled = function () {

    this.addRecentSearch();
};

/**
 * Listen for the icon bar container scroll event
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.onIconBarScrolled = function () {

    this.addRecentSearch();
};

/**
 * Listen for the event results clicking event
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.onEventResultItemClick = function () {

    this.addRecentSearch();
};

/**
 * Listen for the sport results clicking event
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.onIconBarItemClick = function () {

    this.addRecentSearch();
};

/**
 * Listen for messages about successful requests and updates the `shouldSearchTermBeSaved`
 *
 * @param eventName
 * @param requestConfig
 */
SearchRecentController.prototype.onRequestSuccess = function (eventName, requestConfig) {

    this.shouldSearchTermBeSaved = requestConfig.shouldSearchTermBeSaved;
};

/**
 * Listen for messages about failed requests and updates the `shouldSearchTermBeSaved`
 *
 */
SearchRecentController.prototype.onRequestFailed = function () {

    this.shouldSearchTermBeSaved = false;
};

/**
 * Listen for search state reset events and updates the `shouldSearchTermBeSaved`
 *
 */
SearchRecentController.prototype.onStateReset = function () {

    this.shouldSearchTermBeSaved = false;
};

/**
 * Recent Searches Update
 *
 * @returns {void}
 */
SearchRecentController.prototype.updateRecentSearches = function () {
    window.WH.messageBus.publish(MessageBusTopics.SEARCH_RECENT_SEARCHES_UPDATE, this.recentSearches.getItems());
};

/**
 * Adds the latest search term to the
 *
 * @returns {void}
 *
 * @private
 */
SearchRecentController.prototype.addRecentSearch = function () {

    if (this.shouldSearchTermBeSaved) {

        this.shouldSearchTermBeSaved = false;
        var actualSearchState = this.searchService.getState();
        var searchString = actualSearchState.recentlyRequestedSearchString || actualSearchState.searchString;
        this.recentSearches.addItem(searchString);
        this.updateRecentSearches();
    }
};

export default SearchRecentController;
